import { useState } from "react";
import classNames from "classnames";
import validador from "../utils/validador";
import { apiRequest } from "../utils/apiRequest";
import { createBrowserHistory } from "history";


const Formulario = ({
    cid,
    response,
}) => {

    const [nombre, setNombre] = useState(undefined);
    const [email, setEmail] = useState(undefined);
    const [telefono, setTelefono] = useState(undefined);
    const [aceptarCondiciones, setAceptarCondiciones] = useState(false);

    // Estados para errores
    const [showErrorNombre, setShowErrorNombre] = useState(false);
    const [errorNombre, setErrorNombre] = useState('');

    const [showErrorEmail, setShowErrorEmail] = useState(false);
    const [errorEmail, setErrorEmail] = useState('');

    const [showErrorTelefono, setShowErrorTelefono] = useState(false);
    const [errorTelefono, setErrorTelefono] = useState('');

    const [showErrorCondiciones, setShowErrorCondiciones] = useState(false);


    let history = createBrowserHistory();

    //al pulsar el boton de enviar
    const enviarFormulario = async () => {

        let formularioValido = true;

        // Validación del nombre
        if (validador("#abc_", nombre, true, 1, 0, "i")) {
            setShowErrorNombre(true);
            setErrorNombre('Introduce un nombre válido');
            formularioValido = false;
        } else {
            setShowErrorNombre(false);
            setErrorNombre('');
        }


        // Validación del email
        if (validador("email", email, true)) {
            setShowErrorEmail(true);
            setErrorEmail('Introduce un email válido');
            formularioValido = false;
        } else {
            setShowErrorEmail(false);
            setErrorEmail('');
        }

        // Validación del teléfono
        if (validador("movilTelefono", telefono, true)) {
            setShowErrorTelefono(true);
            setErrorTelefono('Introduce un teléfono válido');
            formularioValido = false;
        } else {
            setShowErrorTelefono(false);
            setErrorTelefono('');
        }


        // Validación de aceptación de condiciones
        if (!aceptarCondiciones) {
            setShowErrorCondiciones(true);
            formularioValido = false;
        } else {
            setShowErrorCondiciones(false);
        }


        //Conexión a BASE DE DATOS. Envio de datos.

        if (formularioValido) {

            let url = `https://salesforce.gaolania.com.es/addlead?cid=${cid}&name=${nombre}&phone=${telefono}&email=${email}`;

            try {

                let res = apiRequest(
                    "get",
                    url,
                    null,
                    null,
                    {
                        ignoreBaseUrl: true
                    }
                );

                if (res) {

                    return history.push(response)

                }

            } catch (err) {
                console.log(err);
            }

        }

    }



    //Iconos del checkbox
    const aceptado = 'M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z';
    const noAceptado = 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z';

    const Icon = ({ fill, icon }) => {
        return <svg
            width={22}
            height={22}
            viewBox="0 0 22 22"
            fill={fill}
            xmlns="http://www.w3.org/200/svg"
        >
            <path d={icon} fill-rule="evenodd" />
        </svg>
    };

    // const ModalPoliticaPrivacidad = ({ visible, title, mensajeAlerta, ok, cancel }) => {

    //     return <Modal

    //         title={title}
    //         width={'90%'}
    //         centered
    //         visible={visible}
    //         mensajeAlerta={mensajeAlerta}
    //         onOk={ok}
    //         onCancel={cancel}
    //         className={'modalTextosLegales'}
    //     >
    //         {mensajeAlerta}
    //     </Modal>
    // };


    return (
        <>

            {/* {
                avisoLegalModalVisible === true &&

                <ModalPoliticaPrivacidad
                    visible={avisoLegalModalVisible}
                    mensajeAlerta={<AvisoLegalLanding />}
                    ok={() => setAvisoLegalModalVisible(false)}
                    cancel={() => setAvisoLegalModalVisible(false)}

                />
            } */}

            <div className='flex flex-col w-full' >

                <div className="flex flex-col gap-4 w-full">

                    <div className="flex flex-col">

                        <label className='flex med mb-1 colNeg100'> Nombre completo/Razón Social *</label >

                        <input
                            className={classNames(
                                'py-3 px-4 rounded-xl reg w-full bgNeg100',
                                { 'border-2 border-red-600': showErrorNombre }
                            )}
                            type="text"
                            placeholder="Introduce tu nombre / razón social"
                            value={nombre}
                            onChange={(e) => {
                                setNombre(e.target.value);
                                setShowErrorNombre(false)
                            }}
                        />

                        {
                            showErrorNombre &&
                            <p className="text-red-400 text-[10px] mt-1"> {errorNombre} </p>
                        }

                    </div>

                    <div className="flex flex-col">

                        <label className='flex med mb-1 colNeg100'> Email *</label >

                        <input
                            className={classNames(
                                'py-3 px-4 rounded-xl reg w-full bgNeg100',
                                { 'border-2 border-red-600': showErrorEmail }
                            )}
                            type="email"
                            placeholder="Introduce tu email"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setShowErrorEmail(false)
                            }}
                        />

                        {
                            showErrorEmail &&
                            <p className="text-red-400 text-[10px] mt-1">{errorEmail} </p>
                        }

                    </div>

                    <div className="flex flex-col">

                        <label className='flex med mb-1 colNeg100'> Teléfono *</label >

                        <input
                            className={classNames(
                                'py-3 px-4 rounded-xl reg w-full bgNeg100',
                                { 'border-2 border-red-600': showErrorTelefono }
                            )}
                            type="tel"
                            placeholder="Introduce tu número de teléfono"
                            value={telefono}
                            onChange={(e) => {
                                setTelefono(e.target.value);
                                setShowErrorTelefono(false)
                            }}
                        />

                        {
                            showErrorTelefono &&
                            <p className="text-red-400 text-[10px] mt-1"> {errorTelefono}</p>
                        }

                    </div>


                    <div className={classNames('flex flex-col  justify-start mt-1')} >
                        <div className={classNames('flex items-center justify-start mt-1')}>

                            <div onClick={() => { setAceptarCondiciones(!aceptarCondiciones); setShowErrorCondiciones(aceptarCondiciones) }}>

                                {aceptarCondiciones ? (
                                    <Icon icon={aceptado} fill='#55D3BA' />
                                ) : (
                                    <Icon icon={noAceptado} fill="#ffffff" />
                                )}
                            </div>

                            <p className="inline ml-2 text-[10px] colNeg100 font-thin leading-tight">
                                He leído y acepto las condiciones previstas en el aviso legal y en la política de privacidad *.
                            </p>
                        </div>


                        {showErrorCondiciones && <p className="text-red-400 text-[10px] mt-1">Debes aceptar las condiciones</p>}

                    </div>


                    <div className={"butBoxWra mx-auto"}>
                        <button
                            className={`butBox butBoxVer font-medium text-base flex gap-3 items-center py-4 px-10 rounded-full cursor-pointer`}
                            onClick={() => enviarFormulario()}
                        >Enviar
                            <img
                                src="/assets/img/flecha.svg"
                                alt={"Formulario Gana Energía"}
                                width={12}
                                height={12}
                            />

                        </button>
                    </div>

                </div>

            </div>

        </>
    );
};

export default Formulario;
